/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';

export const ContractsTabelHeader = [
  {
    headerName: 'Contract ID',
    field: 'contractSeqNum',
    editable: false,
    sortable: true,
    cellRenderer: 'ContractIdRenderer',
    minWidth: Styles.Width_150,
    excelAlignment: 'right',

    cellStyle: { textAling: 'right', 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Rebate Program',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'RebateProgramCdRenderer',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Contract Name',
    field: 'contarctName',
    editable: false,
    sortable: true,
    columnSpan: 3,
    minWidth: Styles.Width_450,
    cellRenderer: 'ContractNameRenderer',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  

  {
    headerName: 'Start Date',
    field: 'startDt',
    cellRenderer: 'StateDateRenderer',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    cellRenderer: 'EndDateRenderer',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
